import { render, staticRenderFns } from "./preorder-shorted-sku.vue?vue&type=template&id=2885a501&"
import script from "./preorder-shorted-sku.vue?vue&type=script&lang=ts&"
export * from "./preorder-shorted-sku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports